// @flow
import {createActions} from 'redux-actions';

import type {ImpactRadiusType} from './index';

export const defaultState = {
    email: '',
};

export const {
    impactRadius: {setCustomerEmail},
} = createActions({
    IMPACT_RADIUS: {
        SET_CUSTOMER_EMAIL: (email: string): ImpactRadiusType => ({email}),
    },
});
